import { makeStyle } from '../../../../../utils';
import { blackMedium, blackOutline, subTitle2, caption, secondary,button } from '../../../../../resources/styles';
import view from '../../../../../Enums';

const styles = {};

styles['instruction_box'] = makeStyle({},{
    border:`1px solid ${blackOutline.color}`,
    boxSizing: 'border-box',
    borderRadius: '6px',
    display:'flex',
    marginBottom:'10px'
},view.DESKTOP,{borderBottom:`1px solid ${blackOutline.color}`,paddingBottom:'16px',paddingTop:'16px'});

styles['instruction_left'] = makeStyle({
    ...subTitle2,
    ...blackMedium
},{
    borderRight:`1px solid ${blackOutline.color}`,
    padding:'16px',
    width:'25%'
},view.DESKTOP,{
    marginBottom:'8px'
});

styles['instruction_right'] = makeStyle({},{
    padding:'16px',
    width:'75%',
    display:'flex'
},view.DESKTOP);

styles['ol'] = makeStyle({paddingLeft: 15,margin:0});

styles['instruction_title'] = makeStyle({...subTitle2,textAlign:'justify'},{},view.DESKTOP);

styles['content_parent'] = makeStyle({},{width:'75%'},{width:'65%'},{});

styles['instruction_sub'] = makeStyle({...caption,...blackMedium,marginTop:'8px',textAlign:'justify'},{},view.DESKTOP);

styles['action_btn_wrapper'] = makeStyle({},{marginLeft:'auto',width:'max-content'},view.DESKTOP,{marginTop:'11px'});

styles['action_btn'] = makeStyle({...button,...secondary,marginLeft:'auto'},{},view.DESKTOP);

export default styles;